import React from 'react';
import useAdminPermissions from '../hooks/useAdminPermissions';
import { Link, useLocation } from 'react-router-dom';
import { FileText, Users, Shield, BookOpen, CheckCircle, Target, Globe, Mail, Rss, MessageSquare, UserPlus, Settings, ArrowRight, Star } from 'lucide-react';

function AdminNav() {
  const { pathname } = useLocation();
  const { can } = useAdminPermissions();

  const links = [
    { to: '/admin/assignments', label: 'تخصیص داوران', icon: Users, permissions: ['articles.view', 'reviewers.view'] },
    { to: '/reviewer/assignments', label: 'مقالات تخصیص‌یافته به من', icon: FileText },
    { to: '/admin/reviewers', label: 'داوران', icon: Users, permission: 'reviewers.view' },
    { to: '/admin/journal-features', label: 'ویژگی‌های نشریه', icon: Star },
    { to: '/admin/about', label: 'درباره', icon: Settings },
    { to: '/admin/editorial-board', label: 'هیئت تحریریه', icon: Users },
    { to: '/admin/scientific-advisors', label: 'مشاوران علمی', icon: Users },
    { to: '/admin/policies', label: 'سیاست‌های نشریه', icon: CheckCircle },
    { to: '/admin/scope-objectives', label: 'اهداف و دامنه', icon: Target },
    { to: '/admin/history', label: 'تاریخچه', icon: BookOpen },
    { to: '/admin/articles', label: 'مقالات', icon: FileText },
    { to: '/admin/issues', label: 'شماره‌ها', icon: BookOpen },
    { to: '/admin/for-authors', label: 'راهنمای نویسندگان', icon: FileText },
    { to: '/admin/submission-process', label: 'نحوه ارسال مقاله', icon: ArrowRight },
    { to: '/admin/templates', label: 'قالب و الگو', icon: FileText },
    { to: '/admin/ethics-review', label: 'بررسی اخلاقی', icon: Shield },
    { to: '/admin/publication-terms', label: 'شرایط انتشار', icon: FileText },
    { to: '/admin/open-access', label: 'دسترسی آزاد', icon: Globe },
    { to: '/admin/newsletter', label: 'اشتراک خبرنامه', icon: Mail },
    { to: '/admin/rss-feed', label: 'RSS Feed', icon: Rss },
    { to: '/admin/related-journals', label: 'نشریات مرتبط', icon: BookOpen },
    { to: '/admin/information', label: 'اطلاعات', icon: Settings },
    { to: '/admin/complaints-suggestions', label: 'شکایات و پیشنهادات', icon: MessageSquare },
    { to: '/admin/users', label: 'مدیریت کاربران', icon: UserPlus },
    { to: '/admin/roles', label: 'نقش‌ها', icon: Shield },
    { to: '/admin/permissions', label: 'دسترسی‌ها', icon: Shield },
  ];

  const base = 'px-3 py-1.5 rounded font-semibold transition whitespace-nowrap text-xs flex items-center gap-1';

  return (
    <div className="bg-white border-b border-gray-200 sticky top-0 z-40">
      <div className="px-4">
        <div className="flex flex-wrap gap-2 py-3">
          {links.filter(link => (!link.permission || can(link.permission)) && (!link.permissions || link.permissions.every(can))).map(({ to, label, icon: Icon }) => {
            const active = pathname === to;
            const className = active
              ? `${base} bg-blue-700 text-white hover:bg-blue-800`
              : `${base} bg-gray-200 text-gray-700 hover:bg-gray-300`;
            return (
              <Link key={to} to={to} className={className}>
                {Icon && <Icon size={14} />}
                {label}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default AdminNav;
